<template>
  <div class="category-special">
    <Breadcrumb :items="breadcrumbs" />
    <v-container>
      <CategoryTitle :category="category" :showHeaderImg="true" />
    </v-container>
    <category-block
      v-for="(config, idx) in categoryBlockOrderedByPriority"
      :key="config.categoryBlockId"
      :config="config"
      :class="
        `category-block category-block-position-${idx} category-block-${config.priority}`
      "
    />
    <v-container>
      <ebsn-meta
        :target="category"
        path="category_info.FOOTER_DESCRIPTION"
      ></ebsn-meta>
    </v-container>
  </div>
</template>
<style lang="scss">
.category-special {
  .category-block {
    margin-top: 20px;
    .product-slider-card-content {
      color: white;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
<script>
// @ is an alias to /src
import CategoryTitle from "@/components/category/CategoryTitle.vue";
import Breadcrumb from "@/components/navigation/Breadcrumb.vue";
// import CategoryBlock from "@/components/categoryBlock/CategoryBlock.vue";

import categoryMixins from "~/mixins/category";

import get from "lodash/get";

export default {
  name: "CategorySpecial",
  mixins: [categoryMixins],
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 20,
        watchOverflow: true,
        pagination: {
          el: ".firstCategory",

          clickable: true
        }
      },
      count: -1
    };
  },
  components: {
    // CategorySpecialTitle,
    // CategoryBlock,
    CategoryTitle,
    Breadcrumb
  },
  computed: {
    breadcrumbs() {
      let breadCrumbs = [];
      let path = this.breadcrumb;
      if (path && path[0].to === "/" && path.length > 1) {
        return path;
      }
      breadCrumbs.push({
        to: { name: "Home" },
        text: "Homepage",
        exact: true
      });
      breadCrumbs.push({
        to: {
          name: "Category",
          params: {
            pathMatch: this.category.slug
          }
        },
        text: this.category.name,
        exact: true
      });
      if (this.categoryId) {
        let subCategory = this.category.children.find(
          cat => cat.categoryId == this.categoryId
        );
        breadCrumbs.push({
          to: {
            name: "Category",
            params: {
              pathMatch: this.category.slug
            },
            query: { categoryId: subCategory.categoryId }
          },
          text: subCategory.name,
          exact: true
        });
      }
      return breadCrumbs;
    },
    categoryBlockOrderedByPriority() {
      return this.getCategoryBlockOrderedByPriority();
    }
  },
  methods: {
    getCategoryBlockOrderedByPriority() {
      try {
        return this.category.categoryBlocks.sort(this.comparePriority);
      } catch (err) {
        console.log(err);
        return this.category.categoryBlocks;
      }
    },
    comparePriority(obj1, obj2) {
      if (obj1.priority < obj2.priority) {
        return -1;
      }
      if (obj1.priority > obj2.priority) {
        return 1;
      }
      return 0;
    },
    updateCount(count) {
      this.count = count;
    },
    getSliderCard(category) {
      return get(category, "metaData.category_info.HEADER_IMAGE", null);
    }
  },
  metaInfo() {
    return {
      title: get(
        this.category,
        "metaData.category_seo.SEO_TITLE",
        this.category ? this.category.name : ""
      ),
      meta: [
        {
          vmid: "description",
          name: "description",
          content: get(
            this.category,
            "metaData.category_seo.SEO_DESCRIPTION",
            this.$t("meta.category.firstLevel.description", [
              this.category.name
            ])
          )
        },
        {
          vmid: "keywords",
          name: "keywords",
          content: get(this.category, "metaData.category_seo.SEO_KEYWORDS")
        },
        // Open Graph Metas
        {
          property: "og:locale",
          content: "it_IT"
        },
        {
          property: "og:title",
          content: get(
            this.category,
            "metaData.category_seo.SEO_TITLE",
            this.category ? this.category.name : ""
          )
        },
        {
          property: "og:type",
          content: "product.group"
        },
        {
          property: "og:url",
          content: location.href
        },
        {
          property: "og:image",
          content:
            "https://" + window.location.host + global.config.socialLogo ||
            "/logo/social-logo.png"
        },
        {
          property: "og:image:alt",
          content: get(
            this.category,
            "metaData.category_seo.SEO_DESCRIPTION",
            this.$t("meta.category.firstLevel.description", [
              this.category.name
            ])
          )
        },
        {
          property: "og:site_name",
          content: "Demo"
        },
        // Twitter Metas
        {
          name: "twitter:card",
          content: "summary_large_image"
        },
        {
          name: "twitter:title",
          content: get(
            this.category,
            "metaData.category_seo.SEO_TITLE",
            this.category ? this.category.name : ""
          )
        },
        {
          name: "twitter:image",
          content:
            "https://" + window.location.host + global.config.socialLogo ||
            "/logo/social-logo.png"
        },
        {
          name: "twitter:url",
          content: location.href
        }
      ]
    };
  }
  // async mounted() {

  // }
};
</script>
